<div class="data-table-container" #tableContainer>
  <!-- MatSort gère automatiquement les icônes de tri -->
  <table cdk-table
         [dataSource]="paginatedData()"
         [trackBy]="trackRow"
         class="data-table"
         [class.data-table--equal-cols]="equalColumns()"
         [class.data-table--clickable]="clickable()"
         matSort
         (matSortChange)="onSortChange($event)"
         cdkDropList
         cdkDropListOrientation="horizontal"
         (cdkDropListDropped)="drop($event)">

    <!-- Dynamic Columns avec @for (Angular 21) -->
    @for (column of columns(); track column.key) {
      <ng-container [cdkColumnDef]="column.key">
        <th cdk-header-cell cdkDrag *cdkHeaderCellDef mat-sort-header disableClear start="desc"
            [disabled]="column.sortable === false"
            [style.width]="column.width || null">
          {{ column.label | translate }}
          @if (sortAscIcon() && sortDescIcon() && column.sortable !== false) {
            <img class="sort-icon"
                 [src]="currentSort()?.active === column.key && currentSort()?.direction === 'desc' ? sortDescIcon() : sortAscIcon()"
                 [class.sort-icon--active]="currentSort()?.active === column.key && currentSort()?.direction !== ''"
                 [style.filter]="sortIconFilter()"
                 alt="" />
          }
        </th>
        <td cdk-cell *cdkCellDef="let row">
          @if (getCellTemplate(column.key); as tpl) {
            <ng-container [ngTemplateOutlet]="tpl"
                          [ngTemplateOutletContext]="{ $implicit: row }">
            </ng-container>
          } @else {
            {{ getCellValue(row, column.key) }}
          }
        </td>
      </ng-container>
    }

    <!-- Header Row -->
    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns()"></tr>
    
    <!-- Data Rows -->
    <tr #dataRow cdk-row *cdkRowDef="let row; columns: displayedColumns(); let i = index" 
        [attr.data-row-key]="row[highlightedRowKey()]"
        [class.clickable]="clickable()"
        [class.highlighted]="isHighlightedRow(row)"
        tabindex="-1"
        (click)="onRowClick(row)"></tr>
  </table>
</div>
